<template functional>
  <svg
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
  >
    <g>
      <path
        d="M6.653,13.319a6.648,6.648,0,1,1,4.9-2.145A6.687,6.687,0,0,1,6.653,13.319Zm0-5.3a3.988,3.988,0,0,0-3.7,2.481,5.314,5.314,0,0,0,7.4,0A3.987,3.987,0,0,0,6.653,8.019Zm0-5.37a2.666,2.666,0,0,1,2,4.43,5.363,5.363,0,0,1,2.607,2.253A5.329,5.329,0,1,0,1.32,6.667a5.279,5.279,0,0,0,.727,2.667A5.361,5.361,0,0,1,4.654,7.08a2.666,2.666,0,0,1,2-4.43Zm0,1.35A1.333,1.333,0,1,0,7.987,5.333,1.334,1.334,0,0,0,6.653,4Z"
        transform="translate(1.346 1.333)"
        fill="#7b8190"
        stroke-width="0"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconCircleUser',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>